import React from 'react'
import { DirectCheckInOutResp } from 'types/event/eventAttendance'

interface HistoryStatusProps {
  status: DirectCheckInOutResp
  isCheckIn: boolean
}

const HistoryStatus: React.FC<HistoryStatusProps> = ({ status, isCheckIn }) => {
  const getStatus = () => {
    if (isCheckIn) {
      if (['checked-in', 'droped-in'].includes(status.checkInStatus))
        return 'Checked-in'
    } else {
      if (['checked-out', 'dropped-out'].includes(status.checkOutStatus))
        return 'Checked-out'
    }
    return ''
  }
  return (
    <h4
      className={`text-12 w-600 ${
        getStatus() === 'Checked-out' ? 'danger-txt' : 'text-prim'
      }`}
    >
      {getStatus()}
    </h4>
  )
}

export default HistoryStatus
